import api, { source } from 'utils/axios';

export default {
  source,
  login: async (data) => {
    return await api.post('/authentication/login', data);
  },
  logout: async (loginID) => {
    return await api.post('/authentication/logout', { loginID });
  }
};
